import React from 'react';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ITextFieldProps, TextField } from '../../../../ui';
import { useFormContext } from 'react-hook-form';

export const FirstName = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<TextField
			type="text"
			label={t('user_form_first_name_label')}
			placeholder={t('user_form_first_name_placeholder')}
			invalid={!!errors.firstName}
			error={errors.firstName?.message as string}
			autoComplete="given-name"
			{...props}
			{...register('firstName')}
		/>
	);
};
